import TradeExceptionDetails from "./TradeExceptionDetails";

export default TradeExceptionDetails;
